import centersSeed from "@/data/centers.generated.json";
import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { MessageCircle, X, Phone } from "lucide-react";
import { API, whatsappLink } from "@/lib/faro";
import { trackClick } from "@/lib/analytics";

export default function FloatingWhatsapp() {
  const [centers, setCenters] = useState(Array.isArray(centersSeed) ? centersSeed : []);
  const [open, setOpen] = useState(false);
  const popRef = useRef(null);
  const [openCall, setOpenCall] = useState(false);
  const callRef = useRef(null);

  useEffect(() => {
    axios.get(`${API}/centers`).then((r) => setCenters(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    const onClick = (e) => {
      if (popRef.current && !popRef.current.contains(e.target)) setOpen(false);
    };
    if (open) document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, [open]);

  useEffect(() => {
    const onClick = (e) => {
      if (callRef.current && !callRef.current.contains(e.target)) setOpenCall(false);
    };
    if (openCall) document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, [openCall]);

  return (
    <div ref={popRef} className="select-none">
      {/* Llamar por telefono: solo movil, junto al FAB de WhatsApp */}
      <div ref={callRef} className="sm:hidden">
        <button
          type="button"
          data-testid="fab-call"
          onClick={() => { setOpenCall((v) => !v); setOpen(false); }}
          className="call-fab"
          aria-label="Llamar por telefono"
        >
          {openCall ? <X size={20} /> : <Phone size={20} />}
        </button>

        {openCall && (
          <div
            className="fixed bottom-24 right-5 z-[60] w-[90vw] max-w-sm rounded-2xl bg-white shadow-2xl border border-[rgba(30,42,143,0.12)] overflow-hidden"
            data-testid="fab-call-popover"
          >
            <div className="bg-[var(--faro-blue)] text-white px-5 py-4">
              <div className="text-xs uppercase tracking-[0.2em] font-bold text-[var(--faro-yellow)]">Llamar ahora</div>
              <div className="font-display font-bold text-lg">Elige tu sede</div>
            </div>
            <div className="p-2 max-h-[55vh] overflow-y-auto">
              {centers.filter((c) => c.phone_landline).map((c) => (
                <a
                  key={c.id}
                  href={`tel:${String(c.phone_landline).replace(/\s+/g, "")}`}
                  data-testid={`fab-call-${c.id}`}
                  className="flex items-center justify-between gap-3 p-3 rounded-xl hover:bg-[var(--faro-bg)] transition-colors"
                >
                  <div>
                    <div className="font-bold text-[var(--faro-text)]">{c.name}</div>
                    <div className="text-xs text-[var(--faro-text-soft)]">{c.phone_landline}</div>
                  </div>
                  <span className="inline-flex items-center gap-1 text-xs font-bold text-[var(--faro-blue)]">
                    <Phone size={14} /> Llamar
                  </span>
                </a>
              ))}
            </div>
          </div>
        )}
      </div>

      <button
        data-testid="fab-whatsapp"
        onClick={() => { setOpen((v) => !v); setOpenCall(false); }}
        className="wa-fab"
        aria-label="WhatsApp"
      >
        {open ? <X size={20} /> : <MessageCircle size={20} />}
        <span className="hidden sm:inline">{open ? "Cerrar" : "WhatsApp"}</span>
      </button>

      {open && (
        <div
          className="fixed bottom-24 right-5 z-[60] w-[90vw] max-w-sm rounded-2xl bg-white shadow-2xl border border-[rgba(30,42,143,0.12)] overflow-hidden"
          data-testid="fab-whatsapp-popover"
        >
          <div className="bg-[var(--faro-blue)] text-white px-5 py-4">
            <div className="text-xs uppercase tracking-[0.2em] font-bold text-[var(--faro-yellow)]">WhatsApp directo</div>
            <div className="font-display font-bold text-lg">Elige tu sede</div>
          </div>
          <div className="p-2 max-h-[55vh] overflow-y-auto">
            {centers.map((c) => (
              <a
                key={c.id}
                href={whatsappLink(c.whatsapp, `Hola, me gustaría información de la sede de ${c.name}`)}
                target="_blank"
                rel="noreferrer"
                data-testid={`fab-center-${c.id}`}
                className="flex items-center justify-between gap-3 p-3 rounded-xl hover:bg-[var(--faro-bg)] transition-colors"
              >
                <div>
                  <div className="font-bold text-[var(--faro-text)]">{c.name}</div>
                  <div className="text-xs text-[var(--faro-text-soft)]">{c.phone_landline}</div>
                </div>
                <span className="inline-flex items-center gap-1 text-xs font-bold text-[#25d366]">
                  <MessageCircle size={14} /> Chatear
                </span>
              </a>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
